/**
 * @typedef {{cd: string, text: string}} Department
 */

/**
 * @param {string} text
 * @param {string} universityCd
 * @returns {Promise<Array<Department>|[]>}
 */
export const getDepartmentList = async (text, universityCd) => {
  const token = /** @type {HTMLInputElement|undefined} */ (document.getElementsByName('_token')[0])?.value ?? ''
  const url = /** @type {HTMLInputElement|undefined} */ (document.getElementById('url_suggest_department'))?.value ?? ''
  const query = new URLSearchParams({ text: text, university_code: String(universityCd) })
  const response = await fetch(url + '?' + query, {
    method: 'GET',
    headers: {
      'X-CSRF-TOKEN': token,
    },
  })

  const responseData = await response.json()
  if (responseData.result === 'success') {
    if (Object.keys(responseData.validation).length > 0) {
      return []
    }
  } else {
    alert('エラーが発生しました')
    return []
  }

  return responseData.data
}
